
const data = [
  {
    id: "terms-btn",
    flexPx: 150,
    content: "Terms of Use",
    route: "/terms",
    isLink: false
  },
  {
    id: "privacy-btn",
    flexPx: 150,
    content: "Privacy Policy",
    route: "/privacy",
    isLink: false
  },
  {
    id: "access-btn",
    flexPx: 150,
    content: "Accessibility Policy",
    route: "/accessibility",
    isLink: false
  },
  {
    id: "attribute-btn",
    flexPx: 150,
    content: "Attribution",
    route: "/attribution",
    isLink: false
  }
];

export default data;